module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_03.e19b64e3.jpg";